<template>
    <!-- Layout inner -->
    <div class="layout-inner program_guide careers">
      <!-- Layout navbar -->
      <navbar></navbar>
      <!-- / Layout navbar -->
      <div class="layout-container">
        <div class="layout-content">
          <template v-if="showLoader">
            <div class="w-100 h-100 d-flex justify-content-center align-items-center">
              <spinner size="large"></spinner>
            </div>
          </template>
          <template v-if="showPage">

            <template v-if="programGuide && programGuide.title">
              <program-guide-title :program-guide="programGuide"></program-guide-title>
            </template>

            <!-- Page content -->
            <div class="container-fluid flex-grow-1 pg_content_container">
              <div class="row">
                <div class="col-12 entity_list_container">
                  <template v-for="relatedProgram in relatedPrograms">
                    <related-program :programGuide="relatedProgram" :sourceProgram="programGuide"></related-program>
                    <!--
                    <div class="row result_row" @click.stop="goToProgramGuideDetail(relatedProgram)">
                      <div class="col-2 thumbnail_container">
                        <div class="thumbnail thumbnail_container" v-if="relatedProgram.thumbnailURL">
                          <img v-bind:src="relatedProgram.thumbnailURL"
                          alt="Img"
                          onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/program-default.svg';">
                        </div>
                        <div class="thumbnail_default_name" v-else :style="{background:setThumbnailBgColor(relatedProgram.uuid)}">
                          <div class="txt_bx" v-html="setTitleInitials(relatedProgram.title)"></div>
                        </div>
                      </div>
                      <div class="col-10 entity_details">
                        <div class="title">
                          <a class="title_txt" href="javascript://">{{relatedProgram.title}}</a>
                        </div>
                      </div>
                    </div>
                    -->
                  </template>
                </div>
              </div>
            </div>
            <!-- / Page content -->
            <program-footer-navbar :pageTitle="'Related Programs'" :returnTo="'programGuideMenu'" :params="{code: code, cipCode: cipCode, programGuideCode: programGuideCode, type: type, isComingFromBookmark: isComingFromBookmark}"></program-footer-navbar>
          </template>
        </div>
      </div>
    </div>
    <!-- Layout inner -->
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ProgramGuideTitle from './ProgramGuideTitle'
import RelatedProgram from './RelatedProgram'
import Navbar from '../../misc/components/./Navbar'
import ProgramFooterNavbar from '../../misc/components/./ProgramFooterNavbar'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'

export default {
  name: 'programGuideRelatedPrograms',
  props: ['code', 'cipCode', 'programGuideCode', 'type', 'isComingFromBookmark'],
  components: {
    Navbar,
    ProgramGuideTitle,
    RelatedProgram,
    ProgramFooterNavbar
  },
  data: () => {
    return {
      programGuide: {},
      showPage: false,
      showLoader: true,
      relatedPrograms: []
    }
  },

  mounted () {
    this.loadProgramGuideInfo()
  },

  methods: {
    ...mapActions([
      'loadUserObj',
      'loadProgramGuide',
      'loadRelatedPrograms'
    ]),
    async loadProgramGuideInfo () {
      await this.loadUserObj()
      this.programGuide = await this.loadProgramGuide({
        cipCode: this.cipCode,
        programGuideCode: this.programGuideCode,
        type: this.type
      })
      this.relatedPrograms = await this.loadRelatedPrograms(this.programGuide.uuid)
      this.showLoader = false
      this.showPage = true
    },
    setTitleInitials (title) {
      let getTitleInitials = title.match(/\b(\w)/g)
      return getTitleInitials.join('')
    },
    setThumbnailBgColor (entityId) {
      let getNumricValue = entityId.replace(/[^0-9]/g, '')
      return '#' + getNumricValue.slice((getNumricValue.length - 8), (getNumricValue.length - 2))
    },
    goToProgramGuideDetail (relatedProgram) {
      let routerParams = {
        code: relatedProgram.code,
        cipCode: relatedProgram.cipCode,
        programGuideCode: relatedProgram.code,
        type: relatedProgram.type,
        isRelatedProgram: true,
        relatedProgramParams: {
          code: this.programGuide.code,
          cipCode: this.programGuide.cipCode,
          programGuideCode: this.programGuide.code,
          type: this.programGuide.type
        },
        isComingFromBookmark: this.isComingFromBookmark
      }
      return this.$router.push({name: 'programGuideAbout', params: routerParams, query: this.$route.query})
    },
    hideUserNamePopup () {
      this.$refs.userNamePopupContainer.$emit('close')
    },
    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    },
    addCommaInNumber (numValue) {
      return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj,
      'enabledFeatures': state => state.dashboard.enabledFeatures,
      'packages': state => state.dashboard.packages
    }),
    userName () {
      if (this.userObj) {
        return this.userObj.firstName + ' ' + this.userObj.lastName
      } else {
        return ''
      }
    },
    exploreProgramsFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    showDescriptionOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultDescription) {
        return false
      }
      return exploreProgramsFlagMap.searchResultDescription.enabled
    },
    showMedianIncomeOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultMedianIncome) {
        return false
      }
      return exploreProgramsFlagMap.searchResultMedianIncome.enabled
    },
    medianIncomeResultLabel () {
      const defaultLabel = 'median income'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultMedianIncome) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.searchResultMedianIncome.label || defaultLabel
    },
    showJobPostingsOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultJobPosting) {
        return false
      }
      return exploreProgramsFlagMap.searchResultJobPosting.enabled
    },
    jobPostingsResultLabel () {
      const defaultLabel = 'job postings'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultJobPosting) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.searchResultJobPosting.label || defaultLabel
    },
    showGrowthRateOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultGrowthRate) {
        return false
      }
      return exploreProgramsFlagMap.searchResultGrowthRate.enabled
    },
    growthRateResultLabel () {
      const defaultLabel = 'growth'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultGrowthRate) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.searchResultGrowthRate.label || defaultLabel
    },
    currencyLabel () {
      return '$'
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideRelatedPrograms.vue